import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mappingFilter'
})
export class MappingFilterPipe implements PipeTransform {
 
  transform(mappings: any[], searchFilter: string): any[] {

    console.log(searchFilter, mappings);
 
    if (searchFilter === undefined || searchFilter === "" || searchFilter.length < 2) {
       return mappings;
    }
 
    searchFilter = searchFilter.toLowerCase();
 
    //  var results = mappings.filter((serviceDate) => {
    //    var matches = serviceDate.AvailableSearchTerms.filter((s) => {
    //      if (s == null) return null;
    //      return (s.toLowerCase().indexOf(searchFilter) > -1)
    //    });
  
    //    return matches.length > 0;
    //  });

    //  return results; 

   }
  

}
